import React from 'react';
import { Stack, Tooltip, Typography } from '@mui/material';

import theme from '@/theme';

interface DefaultCellProps {
  value: string;
  draggable?: boolean;
  onDragStart?: (event: React.DragEvent) => void;
  onDragOver?: (event: React.DragEvent) => void;
  onDrop?: (event: React.DragEvent) => void;
  sx?: object;
  tooltip?: boolean;
}

export const DefaultCell = ({
  value,
  draggable,
  onDragStart,
  onDragOver,
  onDrop,
  sx,
  tooltip,
}: DefaultCellProps) => {
  const typography = (
    <Typography
      variant="subtitle2"
      noWrap={tooltip}
      sx={{
        color: theme.palette.text.primary,
        ...(tooltip && { overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }),
      }}
    >
      {value}
    </Typography>
  );

  return (
    <Stack
      direction="row"
      justifyContent="flex-start"
      alignItems="center"
      sx={{ width: '100%', height: '100%', ...(tooltip && { overflow: 'hidden' }), ...sx }}
      draggable={draggable}
      onDragStart={onDragStart}
      onDragOver={onDragOver}
      onDrop={onDrop}
    >
      {tooltip ? (
        <Tooltip title={value} placement="top">
          {typography}
        </Tooltip>
      ) : (
        typography
      )}
    </Stack>
  );
};
